import React from 'react';

import BusinessVerificationReview from './BusinessVerificationReview';
import BankDetails from './sections/BankDetails';
import BasicInfo from './sections/BasicInfo';
import Beneficiaries from './sections/Beneficiaries';
import Documents from './sections/Documents';
import { Section } from './types';
import { KybSubmissionData, KybSubmissionDocument } from '../../../apis/legitimizer/types';

type Props = {
  feedback?: string;
  section: Section;
  submissionData: KybSubmissionData;
  submissionDocuments: KybSubmissionDocument[];
  onSubmitSuccess: (section: string, skipSection?: boolean) => Promise<void>;
};

const BusinessVerificationFlowSection = ({
  feedback,
  section,
  submissionData,
  submissionDocuments,
  onSubmitSuccess,
}: Props) => {
  switch (section) {
    case 'bank-details':
      return (
        <BankDetails
          feedback={feedback}
          submissionData={submissionData}
          submissionDocuments={submissionDocuments}
          onSubmitSuccess={onSubmitSuccess}
        />
      );
    case 'basic-info':
      return <BasicInfo feedback={feedback} submissionData={submissionData} onSubmitSuccess={onSubmitSuccess} />;
    case 'documents':
      return (
        <Documents feedback={feedback} submissionDocuments={submissionDocuments} onSubmitSuccess={onSubmitSuccess} />
      );
    case 'beneficiaries':
      return <Beneficiaries feedback={feedback} submissionData={submissionData} onSubmitSuccess={onSubmitSuccess} />;
    case 'review':
      return <BusinessVerificationReview />;
    default:
      return null;
  }
};

export default BusinessVerificationFlowSection;
